<template>
  <div class="employee">
    <div v-if="data.employee" class="mb-2">
      <span v-if="data.employee.name" class="name">{{ data.employee.name }}</span>
      <span v-if="data.employee.phone" class="employee__phone">
        {{ data.employee.phone | phone }}
      </span>
    </div>

    <div v-if="data.employee && data.employee.email" class="mb-2">
      <div class="item__label">{{ $t('Common.email') }}</div>
      <div>{{ data.employee.email }}</div>
    </div>

    <div v-if="data.company && data.company.name" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.company') }}</div>
      <div>{{ data.company.name }}</div>
    </div>

    <div v-if="data.supervisor && data.supervisor.name" class="mb-2">
      <div class="item__label text-capitalize">{{ $t('Common.supervisor') }}</div>
      <div>{{ data.supervisor.name }}</div>
    </div>

    <div v-if="data.costCenter && data.costCenter.name" class="mb-2">
      <div class="item__label">{{ $t('Common.costCenter') }}</div>
      <a
        v-if="hasRole('costCenter', 'ROLE_GET_COSTCENTER_ID')"
        class="accent--text"
        @click.prevent="change(
          {
            type: 'costCenter',
            action: null
          },
          {
            id: data.costCenter.id,
            name: data.costCenter.name
          }
        )"
      >
        {{ data.costCenter.name }}
      </a>

      <span v-else>{{ data.costCenter.name }}</span>
    </div>

    <div v-if="data.project && data.project.name">
      <div class="item__label text-capitalize">{{ $t('Common.project') }}</div>
      <a
        v-if="hasRole('project', 'ROLE_GET_PROJECT_ID')"
        class="accent--text"
        @click.prevent="change(
          {
            type: 'project',
            action: null
          },
          {
            id: data.project.id,
            name: data.project.name
          }
        )"
      >
        {{ data.project.name }}
      </a>

      <span v-else>{{ data.project.name }}</span>
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'

export default {
  name: 'TabEmployee',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.reports.tabs'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    change (drawer, data) {
      this.$emit('change', {
        drawer: {
          type: drawer.type,
          action: drawer.action
        },
        data: {
          id: data.id,
          name: data.name
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.employee__phone {
  color: $gray-6;
  display: block;
}
</style>
